import React from "react";
import { Global } from "@emotion/react";

import { styled } from "@mui/material/styles";
import { Box, SwipeableDrawer } from "@mui/material";

import SidebarMobileHeader from './SidebarMobileHeader'
import SidebarFocusAreaControls from "./SidebarFocusAreaControls"
import SidebarTabsContainer from "./SidebarTabsContainer";
import SidebarButtonBar from "./SidebarButtonBar"

const StyledBox = styled(Box)(() => ({
  backgroundColor: "#1b2021",
}));

function SidebarMobile({ open, setOpen }) {
  const isTouchDevice = "ontouchstart" in window || navigator.msMaxTouchPoints;
  const iOS =
    typeof navigator !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  const drawerBleeding = 45;

  return (
    <>
      <Global styles={{
        ".MuiDrawer-root > .MuiPaper-root": {
          height: `calc(50% - ${drawerBleeding}px)`,
          overflow: "visible",
        },
        ".MuiDrawer-modal": {
          inset: "unset !important",
        },
      }} />
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        hideBackdrop
        keepMounted={true}
        ModalProps={{ keepMounted: true }}
        BackdropProps={{ invisible: true }}>
        <SidebarMobileHeader
          drawerBleeding={drawerBleeding}
          open={open}
          setOpen={setOpen}
          isTouchDevice={isTouchDevice} />

        <StyledBox sx={{
          width: "100vw",
          height: "100%",
          p: `15px 10px 10px 10px`,
          overflowY: "auto",
        }}>
        
          <StyledBox sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            rowGap: "10px",
          }}>
            <SidebarFocusAreaControls isMobile={true} />
            <SidebarTabsContainer isMobile={true} sx={{ flexGrow: "1" }} />
            <SidebarButtonBar padTop onlyShowLogo />
          </StyledBox>
          
        </StyledBox>
      </SwipeableDrawer>
    </>
  );
}

export default SidebarMobile;
